<div class="err" *ngIf=" control && control.touched && control.errors">
    <!-- <div *ngIf="control.hasError('notMatch')">Password and Confirm Password must be match</div> -->
    <div *ngIf="control.errors.required" class="text-start">*Required</div>
    <div *ngIf="control.errors.minlength">*Minimum Length {{control.errors.minlength.requiredLength}} Characters
    </div>
    <div *ngIf="control.errors.maxlength">*Maximum Length {{control.errors.maxlength.requiredLength}} Characters
    </div>
    <div *ngIf="(controlName != 'cost') && control.errors.min">*Min {{control.errors.min.min}}
    </div>
    <div *ngIf="control.errors.objectWithIdRequired">Please Select Value from the Dropdown</div>
    
    <div *ngIf="(controlName == 'cost') && control.errors.min">*Product Cost: $0 Minimum Cost: {{control.errors.min.min | currency}}
    </div>
    <div *ngIf="control.errors.max">*Max {{control.errors.max.max}}
    </div>
    <div *ngIf="control.errors.email || control.errors.pattern?.requiredPattern == emailRegex">
        *Please Enter a Valid Email Address
    </div>
    <div *ngIf="control.errors?.fileSize?.valid">
        * Max File Size Is {{control.errors?.fileSize?.maxSize}}
    </div>
    <!-- <div *ngIf="control.errors.fileExt">
        *File Only (JPG , PNG)
    </div> -->
    <!-- ***** end image validation -->
    <div *ngIf=" control.errors.pattern?.requiredPattern == webSiteRegex">
        *Invalid Website URL
    </div>

    <div *ngIf=" control.errors.pattern?.requiredPattern == URlRegex">
        *Invalid URL
    </div>

    <div *ngIf="(controlName != 'fax') && control.errors.pattern?.requiredPattern == phoneUSRegex">
        *Invalid Format (000) 000-0000
    </div>

    <div *ngIf=" control.errors.pattern?.requiredPattern == subdomainPattern">
        *Invalid Subdomain
    </div>

    <!-- ************** start password patterns  -->
    <div
        *ngIf="(controlName == 'password' || controlName == 'password_confirmation' )  && control.hasError('notHasCapitalCase')">
        *Password Should Contain Capital Letters
    </div>
    <div
        *ngIf="(controlName == 'password' || controlName == 'password_confirmation' ) && control.hasError('notHasSmallCase')">
        *Password Should Contain Small Letters
    </div>
    <div
        *ngIf="(controlName == 'password' || controlName == 'password_confirmation' ) && control.hasError('notHasNumber')">
        *Password Should Contain Numbers
    </div>
    <div
        *ngIf="(controlName == 'password' || controlName == 'password_confirmation' ) && control.hasError('notHasSpecialCharacters')">
        *Password Should Contain Special Characters
    </div>
    <!-- passowrd confirmation message -->
    <div *ngIf="control.errors.unmatchedPasswords && control?.value['password_confirmation'] ">
        *Passwords Do Not Match
    </div>
    <!-- ************** end password patterns  -->
     <!-- ************** start hex color patterns  -->
     <div *ngIf="control.hasError('yearOutOfRange')">
        *Year Is Out of Range
    </div>
    <div
    *ngIf="(controlName == 'legend' )  && control.hasError('invalidHexColor')">
    *Invalid HEX Color
    </div>
    <div *ngIf=" control.errors.pattern?.requiredPattern == hexColor">
      *Invalid Hexadecimal Color (#xxxxxx)
    </div>
 <!-- ************** end hex color patterns  -->
 <!-- Start account number confirmation message in payment-->
    <div *ngIf="control.errors.unmatchedBankAccountNumber && control?.value['bank_account_number_confirmation']">
    *Account Numbers Do Not Match
    </div>
     <!-- End account number confirmation message in payment -->
    <div *ngIf="control.errors.pattern?.requiredPattern == numericalRegex">
        *Digits Only
    </div>
    <div *ngIf="control.errors.pattern?.requiredPattern == percentageRegex">
        *Percentage Only (0% to 100%)
    </div>
    <div *ngIf="control.errors.pattern?.requiredPattern == floatRegex">
        *Floats Only
    </div>
    <div *ngIf="control.errors.pattern?.requiredPattern == decimalRegex">
        *Decimal Only
    </div>

    <div *ngIf="control.errors.pattern?.requiredPattern == alphaRegex">
        *Letters Only
    </div>

    <div *ngIf="(controlName != 'fax') && control.errors.pattern?.requiredPattern == phoneRegex">
        *Invalid Phone Ex: (111) 111-1111
    </div>
    <div *ngIf="(controlName == 'fax') && control.errors.pattern?.requiredPattern == faxRegex">
        *Invalid Fax Ex: (111) 111-1111
    </div>

    <div *ngIf="control?.errors?.ccNumber==true">
        *Invalid Card Number
    </div>
    <div *ngIf="control.errors.expDate">
        *Invalid Expiration Date
    </div>
    <!-- ****** start file validation -->
    <div *ngIf="(controlName == 'file') && control.errors.fileExt">
        *File Only (PDF , DOC , DOCX , JPG , PNG)
    </div>
    <div *ngIf="(controlName == 'uploadedFile') && control.errors.fileExt">
        *File Only (PDF)
    </div>
    <div *ngIf="(controlName == 'records' || controlName == 'file_rate') && control.errors.fileExt">
        *File Only (CSV)
    </div>
    <div *ngIf="(controlName == 'records' || controlName == 'file_rate') && control.errors.fileSize">
        * Max File Size Is 8 MB
    </div>

    <div *ngIf="controlName == 'content_file' && control.errors.fileExt">
        *File Only (PDF , DOC , DOCX)
    </div>

    <div *ngIf="(controlName == 'file' || controlName == 'uploadedFile'  || controlName == 'attachement') && control.errors.fileSize">
        * Max File Size Is 100 MB
    </div>
    <!-- ****** end file validation -->

    <!-- ***** start image (branding page) validation -->

    <div *ngIf="(controlName == 'attachPhoto') && control.errors.fileExt">
        *File Only (JPG , PNG , JPEG , SVG)
    </div>
    <div *ngIf="(controlName == 'attachPhoto') && control.errors.fileSize">
        * Max File Size Is 8 MB
    </div>

    <div *ngIf="(controlName == 'attachFile') && control.errors.fileExt">
        *File Only (PDF , DOC , DOCX , txt , xls , xlsm , xlsx)
    </div>
    <div *ngIf="(controlName == 'attachFile') && control.errors.fileSize">
        * Max File Size Is 4 MB
    </div>

    <div *ngIf="control.errors.custom">{{ control.errors.custom }}</div>
</div>
